import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {validateAllFormFields} from '../../../utility/validate-all-fields';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {catchError} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {ProfessionEntity} from '../../../profession/profession-entity';
import {ImmutableListRepositoryService} from '../../../../lib/gelios-field/immutable-list-repository.service';
import {environment} from '../../../../environments/environment';
import {
  BaseUserEmployeeExtendedRegistrationFormModel
} from '../../../user-employee-extended-registration-form/base-user-employee-extended-registration-form.model';
import {NotificationsService} from 'angular2-notifications';
import {EmployeeExtendedRegistrationDataModel} from '../../employee-extended-registration/employee-extended-registration-data.model';
import {RouteLibraryEntity} from '../../../route/route-library-entity';
import {RouteLibraryService} from '../../../route/route-library.service';
import {RouteLibraryAction} from '../../../route/route-library-action';
import {EmployeeRegistrationFormTypes} from '../../employee-extended-registration/employee-extended-registration.model';

@Component({
  selector: 'app-employee-method-registration-form',
  templateUrl: './employee-method-registration-form.component.html',
})
export class EmployeeMethodRegistrationFormComponent {
  professionId: ProfessionEntity | null = null;
  @Input() executorUid: string;
  @Input() executorId: number;
  @Input() routeEntity: RouteLibraryEntity;
  @Output() done: EventEmitter<void> = new EventEmitter<void>();
  stateRequest = null;
  formItems = [];
  formItemsLoading = false;
  registrationFormTypes = [];
  formGroup: FormGroup = null;

  constructor(
    private http: HttpClient,
    protected translate: TranslateService,
    protected activatedRoute: ActivatedRoute,
    protected notificationsService: NotificationsService,
    protected immutableListRepositoryService: ImmutableListRepositoryService,
    protected router: Router,
    protected routeLibrary: RouteLibraryService,
  ) {
    if (this.activatedRoute
      && this.activatedRoute.snapshot
      && this.activatedRoute.snapshot.data
      && this.activatedRoute.snapshot.data.profession_id) {
      this.professionId = this.activatedRoute.snapshot.data.profession_id;
    }
    this.getFormItems();
    this.registrationFormTypes = this.immutableListRepositoryService.getListInstant('registration-form-type');
    this.formGroup = new FormGroup({
      registration_form_type: new FormControl(this.registrationFormTypes[0].id, [Validators.required]),
      form_id: new FormControl(undefined, [Validators.required]),
    });
  }

  confirm() {
    if (this.formGroup.valid) {
      this.stateRequest = this.http.post<EmployeeExtendedRegistrationDataModel>(
        environment.apiBasepoint + 'employee-extended-registration-data',
        {
          ...this.formGroup.value,
          executor_uid: this.executorUid,
          executor_id: this.executorId,
        }
      ).pipe(
        catchError((response) => {
            this.unsubscribe();
            this.notificationsService.error(this.translate.instant('Error'));
            throw response.error;
          }
        ),
      ).subscribe((result) => {
        this.unsubscribe();
        let action: RouteLibraryAction = 'view';
        if (this.formGroup.get('registration_form_type').value === EmployeeRegistrationFormTypes.REGISTRATION_FORM_TYPE_ADMIN) {
          action = 'update';
        }
        this.router.navigateByUrl(this.routeLibrary.getRoute({
          entity: this.routeEntity,
          action: action,
          id: result.id
        }));
      });
    } else {
      validateAllFormFields(this.formGroup);
    }
  }

  closeFormEvent() {
    this.done.emit();
  }

  getFormItems() {
    this.formItemsLoading = true;
    const params = (new HttpParams())
      .append('UserEmployeeExtendedRegistrationFormSearch[profession_id]', this.professionId.toString());
    this.http.get<Array<BaseUserEmployeeExtendedRegistrationFormModel>>(
      environment.apiBasepoint + 'user-employee-extended-registration-form',
      {params: params, observe: 'body'}
    ).pipe(
      catchError((response) => {
          this.formItemsLoading = false;
          throw response.error;
        }
      )
    ).subscribe(result => {
      this.formItems = result;
      this.formItemsLoading = false;
    });
  }

  btnIsDisabled() {
    return this.stateRequest || !this.formGroup.valid;
  }

  unsubscribe() {
    this.stateRequest = null;
  }
}
